import { Slide } from '@/components/core/Slide';
import audioFile from './25-synthography.mp3';

const transcript = `
  Synthografie is een schitterend nieuw beroep, en zo verwacht ik nog veel meer geweldige toepassingen voor 
  generatieve AI. Een wonderland voor mensen met een creatief brein zoals jij, Jonathan.

  Maar Jonathan... ik heb je beloofd dat ik een beetje op de tijd zou letten, en ik zou graag nog wat uitwijden 
  over AI-automatisering zoals wij dit besproken hebben. Ik weet dat je hier uren over kan praten, maar gezien 
  de tijd, zou je het goed vinden als ik dat kort vanuit mezelf vertel?
`;

// Jonathan: Ja geen probleem.

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="full"
      transition="fade"
      networkBackground="full"
    >
      <div className="absolute inset-0 z-0 flex items-center justify-center"></div>
    </Slide>
  );
};
